module.exports = __webpack_public_path__ + "static/img/logo-v.cd216ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/logo-v.png
// module id = tMJS
// module chunks = 1